import React from 'react';
import Currency from '../Currency';
import IHasLinkProps from './IHasLinkProps';
import LinkThatCanBeDisabled from '../../shared/permissions/LinkThatCanBeDisabled';
import { IPayoffViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { convertToFloat } from '../../../ui-toolkit/utilities/convertToFloat';

interface IPurchasePayoffProps extends IHasLinkProps {
  ownerId: string;
  data: IPayoffViewItem;
  hasEditPermissions?: boolean;
}

/*tslint:disable-next-line:variable-name*/
const PurchasePayoff = ({ data, ownerId, hasEditPermissions }: IPurchasePayoffProps) => {
  return (
    <div className="cost-data__row cost-data__aligned-row">
      <span
        className={`cost-data__content-cell cost-data__content-row-number ${
          !data ? 'cost-data__content-row-number--hidden-counter' : ''
        }`}
      />
      <span className="cost-data__content-cell cost-data__content-name">
        {data ? `Payoff ${data.label ? `of ${data.label}` : ''} to ${data.payee || ''}` : null}
      </span>
      <span className="cost-data__content-cell cost-data__content-amount cost-data__content-amount--text-content">
        {data ? (
          <LinkThatCanBeDisabled to={`section-a-j#payoffs`} disabled={!hasEditPermissions}>
            <Currency value={convertToFloat(data.seller_at_closing)} />
          </LinkThatCanBeDisabled>
        ) : null}
      </span>
      <span className="cost-data__content-cell cost-data__content-control" />
    </div>
  );
};

export default PurchasePayoff;
